import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'

const ViewConfirmedOrders = () => {
  return (
    <>
    <Header/>
    <Sidebar/>
    <main className="main" id="main">
    <div className='pagetitle text-bg-info'><h1 className='m-1 p-2 text-white'>ViewConfirmedOrders</h1></div>
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-10">
            <div className="card">
              <div className="card-body">
              <div class="row g-0">
              <div className="card-title">Order Summary</div>
              <div class="col-md-4">
                <img src="assets/img/card.jpg" class="img-fluid rounded-start" alt="..."/>
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <h5 class="card-title">Product Name</h5>
                    <p>Quantity: 2</p>
                    <p>$20.00</p>
                </div>
              </div>
            </div>
              </div>
            </div>
            <div class="card">
            <div class="card-body">
              <h5 class="card-title">Card with titles, buttons, and links</h5>
              <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    </main>
    </>
   
  )
}

export default ViewConfirmedOrders